/* global __webpack_nonce__:writable, __webpack_public_path__:writable */

/**
 * How a bundle loads its chunks (architecture/frontend.md, "Bundles"): webpack adds a script
 * element for a chunk to the head. Two things of the page decide whether the browser runs it.
 *
 * - The nonce of a Content Security Policy: a script element which a script adds needs the nonce
 *   of the page, unless the policy says strict-dynamic. The bundle reads it from its own script
 *   element - only while the bundle runs, which is why this module reads it when it is loaded,
 *   and every bundle with chunks loads it while it runs.
 * - The folder of the chunks: webpack takes the folder of the script which runs (publicPath
 *   "auto"). A site which joins the scripts of its pages into one file in a cache folder (a
 *   page speed extension) moves that script, and not its chunks. The page names the address of
 *   the icon sprite (window.EventGalleryAssets), which lies in the folder of the bundles on
 *   both platforms; so that folder is taken while the page names it.
 *
 * Outside webpack (Vitest) both names are undefined, and nothing is set.
 */

const ownScript = typeof document !== 'undefined' ? document.currentScript : null;

if (typeof __webpack_nonce__ !== 'undefined' && ownScript && ownScript.nonce) {
    __webpack_nonce__ = ownScript.nonce;
}

/**
 * The folder of the bundles, from the address of the icon sprite the page names.
 *
 * @return {?string} the absolute address of the folder, with a slash at its end; null when the
 *                   page names no sprite
 */
export function folderOfTheBundles() {
    const assets = typeof window !== 'undefined' ? window.EventGalleryAssets : undefined;
    const sprite = assets && typeof assets.icons === 'string' ? assets.icons : '';
    if (sprite === '') {
        return null;
    }
    try {
        return new URL('./', new URL(sprite, document.baseURI)).href;
    } catch (e) {
        return null;
    }
}

/**
 * Loads a chunk: `loadChunk(() => import('./x.js'))`. The import() stays in the caller, where
 * webpack sees it and gives the chunk its name.
 *
 * @template T
 * @param {function(): Promise<T>} load
 * @return {Promise<T>}
 */
export function loadChunk(load) {
    const folder = folderOfTheBundles();
    if (folder !== null && typeof __webpack_public_path__ !== 'undefined') {
        __webpack_public_path__ = folder;
    }
    return load();
}
